import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export const newsService = {
    getAllNews: async () => {
        try {
            const response = await axios.get(`${API_URL}/news`);
            return response.data;
        } catch (error) {
            throw error;
        }
    },

    getNewsById: async (id) => {
        try {
            const response = await axios.get(`${API_URL}/news/${id}`);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}; 